export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_q01_b.0a82204f.png";